import { useState } from 'react'
import { Link, Text } from '@radix-ui/themes'
import { useAuth } from '~/auth/AuthProvider'
import { openReturnLabel } from '../service'

interface ReturnLabelLinkProps {
  path: string
}

export const ReturnLabelLink = ({ path }: ReturnLabelLinkProps) => {
  const { supabaseClient } = useAuth()
  const [error, setError] = useState<string | null>(null)

  return (
    <>
      <Link size="2" className="whitespace-nowrap" asChild>
        <button
          type="button"
          onClick={() => {
            setError(null)
            openReturnLabel(supabaseClient, path).catch((err: Error) => setError(err.message))
          }}
        >
          View label
        </button>
      </Link>
      {error ? (
        <Text size="1" color="red">
          {error}
        </Text>
      ) : null}
    </>
  )
}
